const PREFETCH_LINKS = false;

Shopify = Shopify || {}
Shopify.theme = Shopify.theme || {}
/*************** DOM ***************/
Shopify.theme.dom = {
    init : function(){
        let that = this;
        this.calculateMainMinHeight();
        window.addEventListener('resize', (event) => {
            that.calculateMainMinHeight();
        });
        if(document.querySelector('external-video')){
            let iframe_api = document.createElement('script');
            iframe_api.id = 'iframe_api';
            iframe_api.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(iframe_api);
        }
    },
    calculateMainMinHeight : function(){
        document.querySelector('main').style.minHeight = 'calc(100vh - ' + document.querySelector('header').offsetHeight + 'px - ' + document.querySelector('footer').offsetHeight +'px)'
    }
};
Shopify.theme.dom.init();
/*************** LINKS ***************/
Shopify.theme.links = {
    init : function(){
        Shopify.theme.links.scrollToView();
        window.onload = function(){
            setTimeout(function(){
                Shopify.theme.links.prefetchLinks();
            }, 10000);
        }
    },
    /*************** SCROLL TO VIEW ***************/
    scrollToView : function(){
        document.querySelectorAll('a').forEach(
            element => {
                let url = new URL(element.href)
                if(url.hash != '' && url.pathname == location.pathname){
                    element.addEventListener('click',function(event){
                        event.preventDefault()
                        window.scrollTo(0,document.querySelector(url.hash).offsetTop)
                    })
                }
            }
        )
        window.addEventListener('load',function(){
            if(location.hash != ''){
                let url = location;
                window.scrollTo(0,document.querySelector(url.hash).offsetTop)
                history.replaceState({}, document.title, window.location.pathname + window.location.search);
            }
        })
    },
    /*************** PREFETCH LINKS ***************/
    prefetchLinks : function(){
        if ( PREFETCH_LINKS ) {
            var [ arrayNewPrefetch, newPrefetch ] = [ [] ];
            Array.from( document.querySelectorAll('a') ).forEach(element => {
                if (!element.href.includes('#') && !element.href.includes('mailto:') && element.href !== 'javascript:void(0);' && element.href !== 'javascript:void(0)' && element.href !== '' ) {
                    if( arrayNewPrefetch.includes( element.href ) === false ) {
                        newPrefetch = document.createElement('link');
                        newPrefetch.rel = "prefetch";
                        newPrefetch.href = element.href;
                        document.head.appendChild(newPrefetch);
                        arrayNewPrefetch.push( element.href );
                    }
                }
            })
        }
    }
}
Shopify.theme.links.init();
/*************** TOOLS ***************/
Shopify.theme.tools = {
    handleize: function(value){
        let handle =  value.toString().split(' ').join('-');
        handle = handle.toLowerCase();
        return handle
    },
    formatMoney: function (cents, format){
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let money_format = format;
        switch(money_format.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2, ",", ".");
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 2, "'", ".");
                break;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = (typeof precision != 'undefined' ? precision : 2);
            thousands = (typeof thousands != 'undefined' ? thousands : ".");
            decimal   = (typeof decimal != 'undefined' ? decimal : ",");

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.');
            let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            let cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }
        return money_format.replace(placeholderRegex, value)
    },
    /*************** SHOPIFY COMMON.JS (PROVINCE SELECTOR) ***************/
    bind: function(t,e){
        return function(){
          return t.apply(e,arguments)
        }
    },
    setSelectorByValue: function(t,e){
        for(var n=0,i=t.options.length;n<i;n++)
        {
            var o=t.options[n];
            if(e==o.value||e==o.innerHTML)
                return t.selectedIndex=n
        }
    },
    postLink: function(t,e){
        var n = ( e = e || {}).method || "post";
        i = e.parameters || {};
        o = document.createElement("form");
        for(var r in o.setAttribute("method", n),o.setAttribute("action",t),i){
            var l = document.createElement("input");
            l.setAttribute("type","hidden");
            l.setAttribute("name",r);
            l.setAttribute("value",i[r]);
            o.appendChild(l)
        }
        document.body.appendChild(o);
        o.submit();
        document.body.removeChild(o);
    }
}

Shopify.theme.tools.CountryProvinceSelector = function(t,e,n){
    this.countryEl = document.getElementById(t);
    this.provinceEl = document.getElementById(e);
    this.provinceContainer = document.getElementById(n.hideElement||e);
    this.countryEl.addEventListener('change', Shopify.theme.tools.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince();
}

Shopify.theme.tools.CountryProvinceSelector.prototype = {
    initCountry: function(){
        var t = this.countryEl.getAttribute("data-default");
        Shopify.theme.tools.setSelectorByValue(this.countryEl,t);
        this.countryHandler();
    },
    initProvince: function(){
        var t=this.provinceEl.getAttribute("data-default");
        t && 0 < this.provinceEl.options.length && Shopify.theme.tools.setSelectorByValue(this.provinceEl,t);
    },
    countryHandler: function(){
        var t=(i=this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces");
        e=JSON.parse(t);
        if(this.clearOptions(this.provinceEl),e&&0==e.length)
            this.provinceContainer.style.display="none";
        else{
            for(var n=0;n<e.length;n++){
                var i;(i=document.createElement("option")).value=e[n][0];
                i.innerHTML=e[n][1],this.provinceEl.appendChild(i);
            }
            this.provinceContainer.style.display = "";
        }
    },
    clearOptions: function(t){
        for(;t.firstChild;)
            t.removeChild(t.firstChild);
    },
    setOptions: function(t,e){
        var n=0;
        for(e.length;n<e.length;n++){
            var i=document.createElement("option");
            i.value = e[n];
            i.innerHTML = e[n];
            t.appendChild(i);
        }
    }
}

Shopify.currency.moneyFormat = null;
/*************** CART ***************/
Shopify.theme.cart = {
    init : function(){
        window.addEventListener('cart:add',function(e){
            e.preventDefault();
        })
    },
    /**
        * 
        * @callback cartCallback
        * @param {Object} response
    */

    /**
        * @param {Object} itemsToAdd - products to add example: {items:[{id: variant.id, quantity: variant.quantity}]}
        * @param {boolean} events - fire cart:add event default true.
        * @param {cartCallback} callback - the callback that handles the response.
    */
    addToCart : function (itemsToAdd, events = true, callback = (products) => {}) {
        let that = this;
        fetch('/cart/add.js', {
                body: JSON.stringify(itemsToAdd),
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
                method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    return response.text().then(text => {
                        let error;
                        try { error = JSON.parse(text); } catch(e) { error = { message: text }; }
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                        throw new Error(error.message || error.description || 'Add to cart failed');
                    });
                } else {
                   return response.json();
                }   
            }).then(function(products) {
                callback(products);
                if(events){
                    window.dispatchEvent(new CustomEvent("cart:add", {detail:{products}}));
                }
            }).catch(function(err) {
                console.error(err);
                that.showErrorToast(err.message || 'Produkt konnte nicht hinzugefügt werden');
                window.dispatchEvent(new CustomEvent("cart:add:error", {detail:{error: err}}));
            }
        );
    },
    showErrorToast : function(message) {
        let existing = document.getElementById('cart-error-toast');
        if(existing) existing.remove();
        let toast = document.createElement('div');
        toast.id = 'cart-error-toast';
        toast.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#d32f2f;color:#fff;padding:16px 24px;border-radius:8px;font-size:16px;font-weight:600;z-index:10000;box-shadow:0 4px 12px rgba(0,0,0,0.3);max-width:90vw;text-align:center;transition:opacity 0.3s ease;';
        toast.textContent = message;
        document.body.appendChild(toast);
        setTimeout(function(){
            toast.style.opacity = '0';
            setTimeout(function(){ toast.remove(); }, 300);
        }, 4000);
    },
    /**
        * @param {boolean} events - fire cart:add event default true.
        * @param {cartCallback} callback - the callback that handles the response.
    */
    getCart: function (events = true, callback = (cart) => {}){
        fetch('/cart.js', {
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'GET'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                    })
                } else {
                   return response.json();
                }   
            }).then(function(cart) {
                callback(cart);
                if(events){
                    window.dispatchEvent(new CustomEvent("cart:changed", {detail:{cart}}));
                }
            }).catch(function(err) {
                console.error(err)
            });
    },
    /**
        * @param {Object} itemsToUpdate - items to update example: {updates:{variant.id: 2}}
        * @param {boolean} events - fire cart:add event default true.
        * @param {cartCallback} callback - the callback that handles the response.
    */
    updateCart: function (itemsToUpdate, events = true, callback = (cart) => {}){
        fetch('/cart/update.js', {
            body: JSON.stringify(itemsToUpdate),
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
        }).then(function(response) {
            if(!response.ok) {
                response.text().then(text => {
                    let error = JSON.parse(text);
                    console.error(error.status);
                    console.error(error.message);
                    console.error(error.description);
                })
            } else {
               return response.json();
            }   
        }).then(function(cart) {
            callback(cart);
            if(events){
                window.dispatchEvent(new CustomEvent("cart:changed", {detail:{cart}}));
            }
        }).catch(function(err) {
            console.error(err)
        });
    },
    /**
        * @param {boolean} events - fire cart:add event default true.
        * @param {cartCallback} callback - the callback that handles the response.
    */
    clearCart: function (events = true, callback = (cart) => {}){
        fetch('/cart/clear.js', {
            body: '',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                    })
                } else {
                   return response.json();
                }   
            }).then(function(cart) {
                callback(cart);
                if(events){
                    window.dispatchEvent(new CustomEvent("cart:changed", {detail:{cart}}));
                }
            }).catch(function(err) {
                console.error(err)
            });
    },
    /**
        * @param {Object} itemToChange - item to change example: {id: variant.key, quantity: variant.quantity}
        * @param {boolean} events - fire cart:add event default true.
        * @param {cartCallback} callback - the callback that handles the response.
    */
    changeItem: function (itemToChange, events = true, callback = (cart) => {}){
        fetch('/cart/change.js', {
            body:  JSON.stringify(itemToChange),
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                    })
                } else {
                    return response.json();
                }   
            }).then(function(cart) {
                for (const item of cart.items) {
                    if(item.key == itemToChange.id && item.quantity != itemToChange.quantity)
                        console.error("inventory_quantity reached old quantity remains!");
                }
                callback(cart);
                if(events){
                    window.dispatchEvent(new CustomEvent("cart:changed", {detail:{cart}}));
                }
            }).catch(function(err) {
                console.error(err)
            });
    }
};
Shopify.theme.cart.init();


/* Custom Components */

/* External Video */
function VideoControls() {
    return Reflect.construct(HTMLElement, [], this.constructor);
}
VideoControls.prototype = Object.create(HTMLElement.prototype);
VideoControls.prototype.constructor = VideoControls;
Object.setPrototypeOf(VideoControls, HTMLElement);
VideoControls.prototype.connectedCallback = function() {
    var that = this;
    if(that.hasAttribute('for')){
        that.for = document.querySelector('#'+that.getAttribute('for'));
        that.addEventListener('click',function(){
            that.for.toggleVideo();
        })
    }
};
customElements.define('video-controls', VideoControls);



function ExternalVideo() {
    return Reflect.construct(HTMLElement, [], this.constructor);
}
ExternalVideo.prototype = Object.create(HTMLElement.prototype);
ExternalVideo.prototype.constructor = ExternalVideo;
Object.setPrototypeOf(ExternalVideo, HTMLElement);
ExternalVideo.prototype.connectedCallback = function() {
    let that = this;
    this.setAttribute('state', 'idle');
};
ExternalVideo.prototype.toggleVideo = function(){
    let that = this;
    if(that.getAttribute('state') == 'idle')
        that.loadVideo();
    else if(that.getAttribute('state') == 'play')
        that.pauseVideo();
    else    
        that.playVideo();
}
ExternalVideo.prototype.loadVideo = function(){
    let that = this;
    this.setAttribute('state', 'load')
    that.youtube_player = new YT.Player(that.querySelector('.iframe_placeholder') , {
        width: '100%',
        height: '100%',
        videoId: that.getAttribute('video-id'),
        autoplay: 1,
        enablejsapi: 1,
        showinfo: 0,
        origin: 'https://clever-2-0.myshopify.com',
        playerVars: {
            origin: 'https://clever-2-0.myshopify.com',
            iv_load_policy: 3,
            modestbranding: 1,
            controls: 0,
            playsinline: 1,
            showinfo: 0,
            playlist: that.getAttribute('video-id'),
            loop: 1,
            mute: 1
        },
        events: {
            'onReady': that.playVideo.bind(that)
        }
    });
};
ExternalVideo.prototype.playVideo = function(){
    this.youtube_player.playVideo();
    this.setAttribute('state', 'play')
};
ExternalVideo.prototype.pauseVideo = function(){
    this.youtube_player.pauseVideo();
    this.setAttribute('state', 'pause')
};
customElements.define('external-video', ExternalVideo);

/* Clever Select web component */
customElements.define('selected-option', class extends HTMLElement {});
customElements.define('clever-options', class extends HTMLElement {});

class CleverSelect extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const that = this;
        //Wrap options in custom container
        this._wrapOptions();
        
        //create value holding input
        this._createValueHolder();

        //Get all options
        this.options = this.querySelectorAll('option')

        //Create selected option display
        this._createSelectedOptionDisplay()
        
        //Set event listener for toggling the Select
        this.querySelector('selected-option').addEventListener('click',(e) => {
            that.toggleOpenState();
        })
        this.options.forEach(option => {
            //Set initial selected option
            if(option.hasAttribute('selected')){
                that._setSelectedOption(option)
            }
            //Add event listeners to all options
            option.addEventListener('click',(e)=>{
                if(!option.hasAttribute('disabled')){
                    e.preventDefault()
                    that._setSelectedOption(option)
                    that.close();
                }
            })
        })
        
        //Set event listener to close when focus out
        document.body.addEventListener('click',(e) => {
            if(that.hasAttribute('open') && !that.contains(e.target)){
                that.close()
            }
        })
    }
    toggleOpenState(){
        if(this.hasAttribute('open')){
            this.removeAttribute('open')
        }
        else{
            this.setAttribute('open','')
        }
    }
    close(){
        this.removeAttribute('open')
    }

    //this functions should only be used by the element itself
    _setSelectedOption(option){
        this.value = option.getAttribute('value')
        this.input.setAttribute('value',this.value)
        this.selectedOption.innerHTML = option.innerHTML;

        this.input.dispatchEvent(new Event('change'))
        this.input.dispatchEvent(new Event('input'))
    }
    _wrapOptions(){
        let wrappedContent = document.createElement('clever-options');
        wrappedContent.innerHTML = this.innerHTML;
        this.innerHTML = wrappedContent.outerHTML;
    }
    _createSelectedOptionDisplay(){
        this.selectedOption = document.createElement('selected-option');
        this.selectedOption.innerHTML = String(this.getAttribute('placeholder'))
        this.appendChild(this.selectedOption)
    }
    _createValueHolder(){
        this.input = document.createElement('input')
        this.input.type = 'text'
        this.input.setAttribute('hidden','')
        this.input.setAttribute('name', this.getAttribute('name'))
        this.removeAttribute('name')
        this.appendChild(this.input)
    }
}

customElements.define('clever-select', CleverSelect);


/* Clever Cart add web component */
class CleverCartAdd extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const that = this;
        this.onclick = (e) => {
            e.preventDefault();
            that.variantId = that.hasAttribute('variant-id') ? that.getAttribute('variant-id') : (document.querySelector('[name="id"]')?.value || null)
            that.quantity = that.hasAttribute('quantity') ? that.getAttribute('quantity') : (document.querySelector('[name="quantity"]')?.value || 1)
            that.selling_plan = that.hasAttribute('selling_plan') ? that.getAttribute('selling_plan') : (document.querySelector('[name="selling_plan"]')?.value || (null)) 
            that.disabled = that.hasAttribute('disabled')
            that.properties = {}
            if(that.hasAttribute('properties')){
                that.getAttribute('properties').split(',').forEach(p => that.properties[p.split(':')[0]] = p.split(':')[1])
            } 
            else{
                Array.from(document.querySelectorAll('[name^="properties"]')).forEach(p => that.properties[p.getAttribute("name").split('[')[1].split(']')[0]] = p.value)
            }
            if(!that.disabled){
                if(!that.variantId || Number(that.variantId) === 0){
                    Shopify.theme.cart.showErrorToast('Bitte wähle eine Option');
                    return;
                }
                Shopify.theme.cart.addToCart({items:[{
                    id: Number(that.variantId),
                    quantity: Number(that.quantity),
                    selling_plan: that.selling_plan != null ? Number(that.selling_plan): null,
                    properties: that.properties
                }]})
            }
        }
    }
}

customElements.define('clever-cart-add', CleverCartAdd);

class InputChange extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        let target = this.getAttribute('for');
        let to = null, by = null;
        if(this.hasAttribute('to'))
            to = Number(this.getAttribute('to'));
        else if(this.hasAttribute('by'))
            by = Number(this.getAttribute('by'));
        this.addEventListener('click', e => {
            let input = document.getElementById(target);
            if(to != null)
                input.value = to;
            else if(by != null)
                input.value = Number(input.value) + by;
            input.dispatchEvent(new Event('change'));
        });
    }
}
customElements.define('input-change', InputChange);

class CleverDrawerToggle extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        const that = this;
        this.for = that.getAttribute('for')
        this.setState(that.getAttribute('state') || 'closed')
        this.setType(that.getAttribute('type') || '')
        this.mode = this.getAttribute('mode').toLowerCase()/* open, close, toggle */

        this.addEventListener('click', (e)=>{
            if(that.mode == 'open'){
                that.open()
            }
            else if(that.mode == 'close'){
                that.close()
            }
            else{
                that.toggle()
            }
        })
    }
    toggle(){
        if(this.state == 'open'){
            this.close()
        }
        else{
            this.open()
        }
    }
    open(){
        this.setState('open',true)
        document.body.classList.add('is-fixed')
        document.getElementById(this.for).open()
    }
    close(){
        this.setState('closed',true)
        document.body.classList.remove('is-fixed')
        document.getElementById(this.for).close()
    }
    setState(state, all = false){
        this.state = state;
        this.setAttribute('state',state)
        if(all){
            document.querySelectorAll('[for="'+ this.for +'"]').forEach(element => {
                element.setState(state)
            })    
        }
        
    }
    setType(type){
        this.type = type;
        this.setAttribute('type',type)
    }
}
customElements.define('clever-drawer-toggle', CleverDrawerToggle);

class CleverDrawer extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        const that = this;
        if(this.hasAttribute('backdrop')){
            document.addEventListener('DOMContentLoaded',(e)=>{
                that._createBackdrop()
            })
        }
        this._setPosition(that.getAttribute('position') || 'left')
    }
    open(){
        this.setState('open')
    }
    close(){
        this.setState('closed')
    }
    setState(state){
        this.state = state;
        this.setAttribute('state',state)
        this.backdrop.setState(state)
    }
    _setPosition(position){
        this.position = position;
        this.setAttribute('position',position)
    }
    _createBackdrop(){
        this.backdrop = document.createElement('clever-drawer-toggle')
        this.backdrop.setAttribute('type', 'backdrop')
        this.backdrop.setAttribute('for', this.id)
        this.backdrop.setAttribute('mode','close')
        this.parentNode.insertBefore(this.backdrop, this);
    }
}
customElements.define('clever-drawer', CleverDrawer);


  
    var aos_script = document.createElement('script')
    aos_script.id = "AOS"
    aos_script.src = "//everjump.fit/cdn/shop/t/174/assets/aos.js?v=137969130111557957861786565790" 
    document.head.appendChild(aos_script)

    var aos_styles = document.createElement('link')
    aos_styles.setAttribute('rel', 'stylesheet');
    aos_styles.setAttribute('type', 'text/css');
    aos_styles.setAttribute('href', "//everjump.fit/cdn/shop/t/174/assets/aos.css?v=171440860698160758581786565789");
    document.head.appendChild(aos_styles)

    document.querySelector('#AOS').addEventListener('load',function(){
        AOS.init();
    })

